import globalApps from '@bingads-webui-clientcenter/global-apps';
import { getUrlHelpers } from '@bingads-webui-clientcenter/url-builder-base';

const { config, pageContext } = globalApps;
const ccBaseUrl = (config && config.get('CCBaseUrl')) || '';
const FwLinkBaseUrl = (config && config.get('FwLinkBaseUrl')) || '';
const CampaignAzureDomain = (config && config.get('CampaignAzureDomain')) || '';
const cid = (pageContext && pageContext.cid) || '';
const uid = (pageContext && pageContext.uid) || '';

const UrlHelper = getUrlHelpers({
  ccBaseUrl,
  FwLinkBaseUrl,
  CampaignAzureDomain,
  cid,
  uid,
});

export default UrlHelper;
